import type { LayoutDataType } from '../../types';

export const TOPICS_OPTIONS: {
  title: string;
  id: LayoutDataType['topics'];
}[] = [
  {
    title: '🫂 Support and acceptance',
    id: 'supportive',
  },
  {
    title: '❤️ Flirting and love',
    id: 'romantic',
  },
  {
    title: '💬 Intelligent conversations',
    id: 'storyteller',
  },
  {
    title: '🎭 Roleplay',
    id: 'dating',
  },
  {
    title: '🧠 Exploring AI capabilities',
    id: 'fun',
  },
];
